import { SummaryRow } from '../../../Summary/SummaryRow';
import { IRisk } from 'types';
import { isFundingRisk } from '../../../../utilities/risks';
import { useTranslation } from "react-i18next";

interface Props {
  id: string;
  showRisks: boolean;
  risk: IRisk['docsRisk']['birthCertificate'];
  isLegalDocument: boolean;
  inEnglish: boolean;
  hasTranslation: boolean;
  uploadedBy?: string;
}

export default function BirthCertificate({
  id,
  showRisks,
  risk,
  isLegalDocument,
  inEnglish,
  hasTranslation,
  uploadedBy,
}: Props) {
    const { t } = useTranslation('forms.visa');
  if (isLegalDocument === undefined) {
    return <div>{t('forms.visa:uploadedBy')} {uploadedBy ? uploadedBy : 'University'}</div>;
  }
  return (
    <>
      <SummaryRow
        key="isLegalDocument"
        label={t('forms.visa:isLegalDocument')}
        fullLabel="Are you uploading a scan of the original legal document?"
        value={isLegalDocument ? 'Yes' : 'No'}
        isRisk={showRisks && isFundingRisk(risk, 'isLegalDocument', id)}
      />

      <SummaryRow
        key="inEnglish"
        label={t('forms.visa:english')}
        fullLabel="Is the letter in English?"
        value={inEnglish ? 'Yes' : 'No'}
        isRisk={showRisks && isFundingRisk(risk, 'inEnglishOrHasTranslation', id)}
      />

      {!inEnglish && (
        <SummaryRow
          key="hasTranslation"
          label={t('forms.visa:hasTranslation')}
          fullLabel="Have you provided an English translation of the letter?"
          value={hasTranslation ? 'Yes' : 'No'}
          isRisk={showRisks && isFundingRisk(risk, 'inEnglishOrHasTranslation', id)}
        />
      )}
    </>
  );
}
